module.exports = __webpack_public_path__ + "static/media/desktop-icon.3362e692.png";